var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAiIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 7.15C2.75 4.71995 4.71995 2.75 7.15 2.75H14.85C17.2801 2.75 19.25 4.71995 19.25 7.15V14.85C19.25 17.2801 17.2801 19.25 14.85 19.25H7.15C4.71995 19.25 2.75 17.2801 2.75 14.85V7.15Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85376 8.16996L7.51411 15.3012H5.62939L8.82573 6.69882H10.0251L9.85376 8.16996ZM11.7976 15.3012L9.452 8.16996L9.26294 6.69882H10.4741L13.6882 15.3012H11.7976ZM11.6912 12.0989V13.4873H7.1478V12.0989H11.6912Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3705 6.69882V15.3012H14.604V6.69882H16.3705Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/aiIcon.28f3e911.svg";
export { ForwardRef as ReactComponent };